/** Orden recomendado de columnas (CSV courier / API típica). El resto va alfabético. */
export const SETTLEMENT_LINE_COLUMN_PRIORITY: string[] = [
  'order_id',
  'warehouse_order_id',
  'shipment_id',
  'tracking',
  'tracking_number',
  'reference',
  'external_reference',
  'type',
  'line_type',
  'shipping_cost',
  'cod_cost',
  'extra_cost',
  'total_cost',
  'amount',
  'fee',
  'tax',
  'discount',
  'currency',
  'matched',
  'match_status',
  'status',
  'import_status',
  'id',
  'courier_charge_line_id',
  'courier_settlement_line_id',
];

export const SETTLEMENT_EXCEPTION_COLUMN_PRIORITY: string[] = [
  'message',
  'reason',
  'error',
  'error_message',
  'description',
  'code',
  'exception_type',
  'type',
  'severity',
  'order_id',
  'warehouse_order_id',
  'tracking',
  'tracking_number',
  'line_number',
  'row_number',
  'source_filename',
  'id',
];

export function collectKeysFromRows(rows: Record<string, unknown>[]): string[] {
  const keys = new Set<string>();
  for (const row of rows) {
    if (row && typeof row === 'object') {
      Object.keys(row).forEach((k) => keys.add(k));
    }
  }
  return [...keys];
}

export function sortColumnKeys(keys: string[], priority: string[]): string[] {
  const rank = new Map<string, number>();
  priority.forEach((k, i) => rank.set(k, i));
  const fallback = 10000;
  return [...keys].sort((a, b) => {
    const ra = rank.has(a) ? rank.get(a)! : fallback;
    const rb = rank.has(b) ? rank.get(b)! : fallback;
    if (ra !== rb) return ra - rb;
    return a.localeCompare(b);
  });
}

export function humanizeColumnKey(key: string): string {
  return key
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}

export function isLikelyMoneyColumn(key: string): boolean {
  const k = key.toLowerCase();
  return (
    /amount|cost|fee|price|charge|total|tax|discount|cod|shipping|extra|balance|paid|due/i.test(k) && !/_id$/i.test(k)
  );
}

export function isLikelyDateColumn(key: string): boolean {
  const k = key.toLowerCase();
  return /_at$|_date$|^date$|^created|^updated|timestamp/i.test(k);
}

export function isLikelyStatusMatchColumn(key: string): boolean {
  const k = key.toLowerCase();
  return /matched|match_status|reconcil|concili/i.test(k);
}
